require('core-js/es/promise');
require('webcrypto-shim');

if (!window.crypto) {
  window.crypto = window.msCrypto;
}
